var jade = require("/build/customer-ui/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div><div ng-if=\"!description() &amp;&amp; !sizing()\" class=\"text-center\"><p>No product details available.</p></div><div ng-if=\"!!sizing()\" class=\"visual pull-right\"><img ng-src=\"{{sizing().sample_image | protocolRelative}}\" alt=\"\"></div><div ng-if=\"!!description()\"><h2>{{name}}</h2><div ng-bind-html=\"description()\"></div></div><div ng-if=\"!!sizing().sizes.length\"><h2>PRODUCT SPECIFICATIONS</h2><div class=\"table-box table-responsive\"><table class=\"table-size\"><thead><tr><th></th><th ng-repeat=\"size in sizing().sizes\"><span class=\"circle\">{{size.size}}</span></th></tr></thead><tbody><tr ng-repeat=\"(key, name) in measurements\"><td>{{name}}</td><td ng-repeat=\"size in sizing().sizes\">{{size[key]}}\"</td></tr></tbody></table></div></div></div>");;return buf.join("");
}


// WEBPACK FOOTER //
// ./source/client/pages/store/product-details/product-details.jade